import React from "react"
import PropTypes from "prop-types"
import { useRefinementList } from "react-instantsearch"
import classNames from "classnames"
import { sortBy } from "lodash"
import filterComponent from "./filter"

const checkboxClasses = (item) =>
  classNames("checkbox", {
    "is-active": item.isRefined,
  })

const trackEvent = (modelCode, modelName, dropdown) => {
  window.dataLayer?.push({
    event: "product-tab",
    productName: modelName,
    productCode: modelCode,
    productTab: "list",
    productDropdown: dropdown,
  })
}

function Checkbox({ item, refine, modelCode, modelName, dropdown }){

  return (<div
    className={checkboxClasses(item)}
    onClick={() => {
      refine(item.value)
      trackEvent(modelCode, modelName, dropdown)
    }}
  >
    <div className="checkbox__indicator">
      {item.isRefined ? (
        <svg>
          <use xlinkHref="#tick" />
        </svg>
      ) : null}
    </div>
    {item.label}
  </div>)
}
  

Checkbox.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    isRefined: PropTypes.bool,
    value: PropTypes.any,
  }).isRequired,
  refine: PropTypes.func.isRequired,
  modelCode: PropTypes.string,
  modelName: PropTypes.string,
  dropdown: PropTypes.string,
}

const Checkboxes = ({ attributeName, modelCode, modelName, dropdown }) => {
   const { items, refine } = useRefinementList({ attribute: attributeName })

  if (!items.length) return null
  const sortedItems = sortBy(items, (item) => item.label)
  return (
    <div className="checkbox-group">
      {sortedItems.map((item) => (
        <Checkbox
          key={item.label}
          item={item}
          refine={refine}
          dropdown={dropdown}
          modelCode={modelCode}
          modelName={modelName}
        />
      ))}
    </div>
  )
}

Checkboxes.propTypes = {
  attributeName: PropTypes.string.isRequired,
  modelCode: PropTypes.string,
  modelName: PropTypes.string,
  dropdown: PropTypes.string,
}
export default filterComponent(Checkboxes)